<template>
    <div>系统通知</div>
</template>

<script>
    export default {
        name: "SysNoticeList"
    }
</script>

<style scoped>

</style>
